import { render, staticRenderFns } from "./articledetail.vue?vue&type=template&id=1e2f687b&scoped=true&"
import script from "./articledetail.vue?vue&type=script&lang=js&"
export * from "./articledetail.vue?vue&type=script&lang=js&"
import style0 from "./articledetail.vue?vue&type=style&index=0&id=1e2f687b&lang=less&scoped=true&"
import style1 from "./articledetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f687b",
  null
  
)

export default component.exports